module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		loadWhenPrimaryKeyPresentOnly: true,
		resourceRegisterKey: 'memberProperties',
	},
}